module.exports = __webpack_public_path__ + "static/media/undraw_profile_pic_ic5t.5463d4fb.png";